import { render, staticRenderFns } from "./NativeAdsData.vue?vue&type=template&id=4efb2a56"
import script from "./NativeAdsData.vue?vue&type=script&lang=js"
export * from "./NativeAdsData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports